exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.personCard .mint-field-core{text-align:left !important\n}\n", ""]);

// exports
